import axios from 'axios';

let countriesCache = null;
let countriesPromise = null;

const CountriesService = {
  load() {
    if (countriesCache) return Promise.resolve(countriesCache);

    if (countriesPromise) return countriesPromise;

    if (typeof window === 'undefined') return Promise.resolve(null);

    countriesPromise = fetch('/data/countries.min.json')
      .then((res) => res.json())
      .then((res) => {
        countriesCache = res;
        countriesPromise = null;
        return countriesCache;
      })
      .catch((err) => {
        countriesPromise = null;
        console.error('Countries loading failed', err);
        return null;
      });

    return countriesPromise;
  },

  get() {
    return countriesCache;
  },

  getCountryCode(name) {
    if (!countriesCache) return null;
    const found = countriesCache.find(
      (c) => c.address && (c.address.en === name || c.address.he === name)
    );
    return found ? found.isoCode : '';
  }
};

export default CountriesService;
